import React, { useContext } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { BrikkContext } from 'components/Brikk/index';
import { Placeholder } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

export const Content = ({ center, children }) => {
  const { isLoading, error } = useContext(BrikkContext);

  return (
    <div
      className={classNames(
        styles.brikkContent, {
          [styles.center]: center,
        }
      )}
    >
      {error ? (
        <div className={styles.error}>
          <FormattedMessage id={error} />
        </div>
      ) : (
        isLoading ? (
          <div className={styles.loading}>
            <Placeholder>
              <Placeholder.Line className={styles.line} />
              <Placeholder.Line className={styles.line} />
              <Placeholder.Line className={styles.line} />
              <Placeholder.Line className={styles.line} />
            </Placeholder>
          </div>
        ) : children
      )}
    </div>
  );
};
